'use client';

import React from 'react';

import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import { AppIcon } from '@/components/AppIcon';
import { t } from '@/utils/lang';

interface TranslationButtonProps {
    open: boolean;
    tooltipOpen: boolean;
    setTooltipOpen: (open: boolean) => void;
    onToggle: (e: React.MouseEvent<HTMLElement>) => void;
}

export default function TranslationButton({
    open,
    tooltipOpen,
    setTooltipOpen,
    onToggle,
}: TranslationButtonProps) {
    return (
        <Tooltip
            title={t('Chuyển đổi ngôn ngữ')}
            open={!open && tooltipOpen}
            onOpen={() => setTooltipOpen(true)}
            onClose={() => setTooltipOpen(false)}
            PopperProps={{ className: 'capitalize' }}
        >
            <span className='inline-flex'>
                <IconButton onClick={onToggle} className='!text-textPrimary'>
                    <AppIcon name='translationGlobal' />
                </IconButton>
            </span>
        </Tooltip>
    );
}
